import { DatePicker } from "antd";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "antd/dist/reset.css";

// Extend Day.js with the relativeTime plugin
dayjs.extend(relativeTime);

export default function DueDatePicker({ task, onUpdateDueDate }) {

  const handleChange = (value) => {
    if(value) {
      onUpdateDueDate(value);
    } else {

    }
  };

  // Format the date in relative time
  const formatRelativeTime = (date) => {
    return date ? dayjs(date).fromNow() : '';
  };

  // Determine if the date is in the past
  const isPastDate = task.status !== 'done' && task.dueDate && dayjs(task.dueDate).isBefore(dayjs());

  const now = dayjs();

  const getDynamicPresets = () => {
    const presets = [];

    // Always-useful quick options
    presets.push({ label: 'In 1 Hour', value: now.add(1, 'hour') });
    presets.push({ label: 'In 2 Hours', value: now.add(2, 'hour') });
    presets.push({ label: 'In 5 Hours', value: now.add(5, 'hour') });

    // Time-based future slots (only included if in the future)
    const slots = [
      { label: 'Morning', value: now.set('hour', 9).set('minute', 0).set('second', 0) },
      { label: 'Noon', value: now.set('hour', 12).set('minute', 0).set('second', 0) },
      { label: 'Evening', value: now.set('hour', 18).set('minute', 0).set('second', 0) },
      { label: 'Night', value: now.set('hour', 23).set('minute', 0).set('second', 0) },
      { label: 'Next Morning', value: now.add(1, 'day').set('hour', 9).set('minute', 0).set('second', 0) },
      { label: 'Next Noon', value: now.add(1, 'day').set('hour', 12).set('minute', 0).set('second', 0) },
      { label: 'Next Evening', value: now.add(1, 'day').set('hour', 18).set('minute', 0).set('second', 0) },
      { label: 'Next Night', value: now.add(1, 'day').set('hour', 23).set('minute', 0).set('second', 0) },
    ];

    // Filter future-only, sort, and take next 5
    const futurePresets = [
      ...presets,
      ...slots.filter(slot => slot.value.isAfter(now))
    ]
      .sort((a, b) => a.value.unix() - b.value.unix())
      .slice(0, 10);

    return futurePresets;
  };

  const presets = getDynamicPresets();

  return (
    <DatePicker
      presets={presets}
      showTime={{ format: "HH:mm" }}
      value={task.dueDate ? dayjs(task.dueDate) : null}
      onChange={handleChange}
      suffixIcon={null}
      allowClear={false}
      variant="borderless"
      placeholder="Due Date"
      format={(value) => formatRelativeTime(value)}
      style={{
        borderColor: isPastDate ? 'red' : undefined, // Change border color if in the past
        color: isPastDate ? 'red' : undefined, // Change text color if in the past
        fontWeight: 'bold'
      }}
      status={isPastDate ? "error" : undefined} // Set warning status if in the past
    />
  );
}
